<!-- Note for backend: this is pulling the same markup and styles as the app-canvass-status-controls component -->
<div class="canvass-status-controls"
     *ngIf="!loading && step === 1">
  <h2 class="mb-0100 border-bottom-0">Log Conversation</h2>
  <div class="mb-0150">
    <h5 class="color--gray--005 caps txt-fw-500 txt-12">Contact Method</h5>
    <hr class="mt-0050">
    <div class="mt-0050">

      <mat-radio-group class="col__"
                       [(ngModel)]="selectedContactMethod">
        <!-- Other -->
        <mat-radio-button class="col__ mb-0050"
                          value="other">
          <span class="txt-16 d-block">
            In Person
          </span>
        </mat-radio-button>

        <!-- No phone number case-->
        <div class="col__ mb-0050"
             *ngIf="!contactPhoneNumber">
          <span class="txt-16 d-block">
            <span class="txt-fw-500 color--gray--007">No Phone Numbers</span>
            <button type="button"
                    class="link link--noline d-block p-0"
                    (click)="addNewClicked('phone')">Add Phone Number</button>
          </span>
          <span class="txt-13 color--gray--005 d-none">
            PHONE NUMBER
          </span>
        </div>

        <mat-radio-button class="col__ mb-0050"
                          *ngIf="contactPhoneNumber"
                          [value]="contactPhoneNumber">
          <div>
            <span class="txt-16 d-block">
              <a *ngIf="!isDoNotContact(contactPhoneNumber)"
                 class="link link--blue link--noline"
                 (click)="selectedContactMethod = contactPhoneNumber"
                 [attr.href]="'tel:' + contactPhoneNumber.number"
                 title="{{contactPhoneNumber.number | phone}} {{contactPhoneNumber.ext ? 'Ext. ' + contactPhoneNumber.ext : ''}}">
                {{contactPhoneNumber.number | phone}}
                {{contactPhoneNumber.ext ? 'Ext. ' + contactPhoneNumber.ext : ''}}</a>
              <span *ngIf="isDoNotContact(contactPhoneNumber)"
                    class="txt-fw-500 color--gray--007"
                    title="{{contactPhoneNumber.number | phone}} {{contactPhoneNumber.ext ? 'Ext. ' + contactPhoneNumber.ext : ''}}">{{contactPhoneNumber.number
                | phone}}
                {{contactPhoneNumber.ext ? 'Ext. ' + contactPhoneNumber.ext : ''}}</span>
              <ng-container *ngTemplateOutlet="contactIconTemplate; context: {item: contactPhoneNumber}"></ng-container>

            </span>
            <span class="txt-13 color--gray--005">
              PHONE NUMBER • ({{contactPhoneNumber.numberType | uppercase}})
            </span>
          </div>
          <!--drawer-->
          <div class="tr__drawer tr__drawer--sm drawer"
               style="top: 0; right: 0;">
            <button mat-icon-button
                    type="button"
                    [matMenuTriggerFor]="additionalNumbers">
              <mat-icon fontSet="far"
                        fontIcon="fa-ellipsis-h"
                        class="fa-fw fa--gray txt-18"></mat-icon>
            </button>

            <mat-menu #additionalNumbers="matMenu">
              <button mat-menu-item
                      type="button"
                      [disabled]="contactPhoneNumber?.id === pn?.id"
                      *ngFor="let pn of getPhones()"
                      (click)="setContactPhoneNumber(pn)">
                <span>
                  {{pn.number | phone}} {{pn.ext ? 'Ext. ' + pn.ext : ''}}
                </span>
                <ng-container *ngTemplateOutlet="contactIconTemplate; context: {item: pn}"></ng-container>
              </button>
              <mat-divider class="mt-0025 mb-0025"
                           *ngIf="getPhones().length > 0"></mat-divider>
              <button mat-menu-item
                      (click)="addNewClicked('phone')"
                      class="txt-15">
                <span class="link link--noline">Add new phone</span>
              </button>
            </mat-menu>
          </div>
          <!-- end drawer-->
        </mat-radio-button>
        <!-- Email-->
        <!-- No email case-->
        <div class="col__ mb-0050"
             *ngIf="!contactEmail">
          <span class="txt-16 d-block">
            <span class="txt-fw-500 color--gray--007">No Emails</span>
            <button type="button"
                    class="link link--noline d-block p-0"
                    (click)="addNewClicked('email')">Add Email</button>
          </span>
          <span class="txt-13 color--gray--005 d-none">
            <button type="button"
                    class="link link--noline"
                    (click)="addNewClicked('email')">Add Email</button>
          </span>
        </div>
        <!-- Has email case-->
        <mat-radio-button class="col__ mt-0050"
                          *ngIf="contactEmail"
                          [value]="contactEmail">
          <span class="txt-16 d-block">
            <a *ngIf="!isDoNotContact(contactEmail)"
               class="link link--blue link--noline"
               (click)="selectedContactMethod = contactEmail"
               title="Click to email {{contactEmail.email}}"
               [attr.href]="'mailto:' + contactEmail.email">
              {{contactEmail?.email}}
            </a>
            <span *ngIf="isDoNotContact(contactEmail)"
                  class="txt-fw-500 color--gray--007">
              {{contactEmail?.email}}
            </span>
            <ng-container *ngTemplateOutlet="contactIconTemplate; context: {item: contactEmail}"></ng-container>
          </span>
          <span class="txt-13 color--gray--005">
            EMAIL
          </span>
          <div class="tr__drawer tr__drawer--sm drawer"
               style="top: 0; right: 0;">
            <button type="button"
                    aria-label="'View additional emails'"
                    [matMenuTriggerFor]="additionalEmails"
                    mat-icon-button>
              <mat-icon fontSet="far"
                        fontIcon="fa-ellipsis-h"
                        class="fa-fw fa--gray txt-18"></mat-icon>
            </button>
            <mat-menu #additionalEmails="matMenu">
              <button mat-menu-item
                      type="button"
                      [disabled]="contactEmail?.id === e?.id"
                      *ngFor="let e of getEmails()"
                      (click)="setContactEmail(e)">
                <span>
                  {{e.email}}
                </span>
                <ng-container *ngTemplateOutlet="contactIconTemplate; context: {item: contactEmail}"></ng-container>
              </button>
              <mat-divider class="mt-0025 mb-0025"
                           *ngIf="getEmails().length > 0"></mat-divider>
              <button mat-menu-item
                      (click)="addNewClicked('email')"
                      class="txt-15">
                <span class="link link--noline">Add New Email</span>
              </button>
            </mat-menu>
          </div>
        </mat-radio-button>

      </mat-radio-group>
    </div>
  </div>

  <ng-container *appIfFeatureOn="'LogAttemptsViaConversation'">
    <div class="mb-0150">
      <h5 class="color--gray--005 caps txt-fw-500 txt-12">Contact Result</h5>
      <hr class="mt-0050">
      <div class="mt-0050">
        <mat-radio-group class="col__"
                         [(ngModel)]="selectedContactResult">
          <mat-radio-button class="col__ mb-0050"
                            value="success">
            <span class="txt-15 d-block"
                  [ngClass]="{ 'txt-fw-600' : selectedContactResult === 'success' }">
              Successfully contacted
            </span>
            <span class="txt-13 color--gray--005">
              Reached the target at the intended contact method
            </span>
          </mat-radio-button>
          <mat-radio-button class="col__ mb-0050"
                            value="attempted">
            <span class="txt-15 d-block"
                  [ngClass]="{ 'txt-fw-600' : selectedContactResult === 'attempted' }">
              Attempted
            </span>
            <span class="txt-13 color--gray--005">
              Tried but unable to reach the target 
            </span>
          </mat-radio-button>
          <mat-radio-button class="col__ mb-0050"
                            value="mark_as_bad"
                            *ngIf="selectedContactMethod !== 'other'">
            <span class="txt-15 d-block"
                  [ngClass]="{ 'txt-fw-600' : selectedContactResult === 'mark_as_bad' }">
              Mark as bad
            </span>
            <span class="txt-13 color--gray--005">
              Wrong contact info for target 
            </span>
          </mat-radio-button>
          <mat-radio-button class="col__ mb-0050"
                            value="do_not_contact"
                            *ngIf="selectedContactMethod !== 'other'">
            <span class="txt-15 d-block"
                  [ngClass]="{ 'txt-fw-600' : selectedContactResult === 'do_not_contact' }">
              Mark as do not contact
            </span>
            <span class="txt-13 color--gray--005">
              This contact method should <strong>never</strong> be attempted
            </span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </ng-container>

  <ng-container *appIfFeatureOff="'LogAttemptsViaConversation'">
    <div class="row mt-0100">
      <div class="col__">
        <button class="btn ml-auto"
                type="button"
                (click)="saveClicked()"
                [disabled]="!selectedContactMethod || saving">
          Log Conversation & Continue
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *appIfFeatureOn="'LogAttemptsViaConversation'">
    <div class="row mt-0100">
      <div class="col__">
        <button *ngIf="selectedContactResult === 'success'"
                class="btn ml-auto"
                type="button"
                (click)="logConversationClicked()"
                [disabled]="!selectedContactMethod || !selectedContactResult || saving">
          Log Conversation & Continue
        </button>
        <button *ngIf="selectedContactResult !== 'success'"
                class="btn ml-auto"
                type="button"
                (click)="logAttemptClicked()"
                [disabled]="!selectedContactMethod || !selectedContactResult || saving">
          Log Attempt
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #contactIconTemplate
               let-item="item">
    <i class="fas fa-ban color--red pair__verified ml-0050"
       *ngIf="isDoNotContact(item)"
       matTooltip="Marked as Do Not Contact"
       matTooltipPosition="above"></i>
    <i class="far fa-times-circle pair__red ml-0050"
       *ngIf="isBad(item)"
       matTooltip="Marked as Bad"
       matTooltipPosition="above"></i>
    <i class="far fa-check pair__verified ml-0050"
       *ngIf="isVerified(item)"
       matTooltip="Confirmed"
       matTooltipPosition="above"></i>
    <i class="far fa-bell-on pair__verified ml-0050"
       *ngIf="item.subscribed"
       matTooltip="Subscribed"
       matTooltipPosition="above"></i>
  </ng-template>
</div>

<div *ngIf="!loading && step === 2">
  <h2>Add {{entity.entityType?.nameSingular | titlecase }} Details</h2>
  <app-contact-attempt-data-entry [entityId]="entityId"
                                  [campaignId]="campaignId">
  </app-contact-attempt-data-entry>
</div>
